var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4002 17.4379L13.4002 4.2624C13.4002 3.82057 13.7584 3.4624 14.2002 3.4624C14.642 3.4624 15.0002 3.82057 15.0002 4.2624V17.0625L19.6762 12.6752C19.994 12.377 20.492 12.3943 20.7885 12.7137C21.0851 13.0332 21.0679 13.5338 20.7502 13.8319L14.5372 19.6614C14.2348 19.9451 13.7656 19.9451 13.4632 19.6614L7.2502 13.8319C6.93245 13.5338 6.91528 13.0332 7.21184 12.7137C7.5084 12.3943 8.0064 12.377 8.32414 12.6752L13.4002 17.4379ZM4.0002 19.6624C4.44202 19.6624 4.8002 20.0205 4.8002 20.4624V24.4624C4.8002 24.5728 4.88974 24.6624 5.0002 24.6624H23.0002C23.1107 24.6624 23.2002 24.5728 23.2002 24.4624V20.4624C23.2002 20.0205 23.5584 19.6624 24.0002 19.6624C24.442 19.6624 24.8002 20.0205 24.8002 20.4624V24.4624C24.8002 25.4565 23.9943 26.2624 23.0002 26.2624H5.0002C4.00608 26.2624 3.2002 25.4565 3.2002 24.4624V20.4624C3.2002 20.0205 3.55837 19.6624 4.0002 19.6624Z",
    fill: "#002364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.b40d50d0.svg";
export { ForwardRef as ReactComponent };